// Sitewide DEMO / TEST DATA warning. Renders at the top of every
// page (mounted in main.tsx above DevBanner) whenever the
// `results_demo_mode` feature flag is 'live'.
//
// Public-visible by design — see the four hard rules in
// src/data/demo/contract.ts. This banner exists so that even if an
// editor flips the toggle and forgets, no reader can mistake demo
// figures for real ones.
//
// The hero winner announcement (Hero.tsx) is real-data-only and
// is NEVER driven by demo mode — see contract rule 3. This banner
// is the public-facing assurance of that contract: if it's present,
// any results map / table on the page is canned data; if it's
// absent, those widgets are reading the live database.

import { useResultsDemoMode } from '../data/demo/contract';

export default function DemoBanner() {
  const isDemo = useResultsDemoMode();
  if (!isDemo) return null;

  return (
    <div
      role="alert"
      aria-label="Demo / test data warning"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10000, // above DevBanner (9999) — demo warning wins.
        width: '100%',
        background:
          'repeating-linear-gradient(45deg, #000 0, #000 14px, #ffcc00 14px, #ffcc00 28px)',
        padding: '4px 0',
      }}
    >
      <div
        style={{
          background: 'var(--red-dark, #cf0a2c)',
          color: '#ffffff',
          fontFamily: "'Poppins', system-ui, sans-serif",
          fontSize: 15,
          fontWeight: 900,
          letterSpacing: 2.5,
          textTransform: 'uppercase',
          padding: '10px 16px',
          textAlign: 'center',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.45)',
          borderTop: '2px solid #000',
          borderBottom: '2px solid #000',
        }}
      >
        ⚠ Demo / Test Data — NOT live results ⚠
      </div>
    </div>
  );
}
